import { useQuery } from 'react-query'
import { toast } from 'react-toastify'
import { axios } from 'lib'
import { PaginatedParams } from 'services/api/types'
import {
  BoundNoteType,
  ListEnvelope
} from '../types/noteTypesAllowZeroInstallments'

const toastId = 'errorLoadNoteTypesAllowZeroInstallments'

const fetcher = (
  params: PaginatedParams
): Promise<ListEnvelope<BoundNoteType>> => {
  const { page = 1, limit = 10 } = params
  return axios.get(`parameters/note-types-allow-zero-installments`, {
    params: { ...params, page, limit }
  })
}

export function useLoadNoteTypesAllowZeroInstallments(data: PaginatedParams) {
  return useQuery(
    ['noteTypesAllowZeroInstallments', data],
    () => fetcher(data),
    {
      onError: () =>
        toast.error(
          'Não foi possível carregar os tipos de nota que permitem parcelas sem financeiro.',
          {
            toastId,
            updateId: toastId
          }
        )
    }
  )
}
